export default "__VITE_ASSET__jtwnoyoW__"